import React from "react";
import CarrierProgramTable from "./CarrierProgramTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const CarrierProgram = () => {
  const viewPermission = PERMISSIONS.permission_utilities_carrierprogram_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <div>
      {/* {userPermissions.includes(viewPermission) && <CarrierProgramTable />} */}
      <CarrierProgramTable />
    </div>
  );
};

export default CarrierProgram;
